<script lang="ts">
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
</script>

<header class="fizz-full-width fizz-border-bottom fizz-stack-24">
  <div
    class="fizz-layout-header fizz-space-between-8-responsive fizz-inset-vertical-16"
    class:fizz-inset-square-16={$LayoutStore.isMobile}
  >
    <div class:fizz-stack-8={$LayoutStore.isMobile}>
      <h3
        class="fizz-stack-8"
        class:fizz-heading-3={$LayoutStore.isDesktop}
        class:fizz-heading-4={$LayoutStore.isMobile}
      >
        New Distributor Account Application
      </h3>
      <p class="fizz-text-medium">
        Apply for a new account with a distributor you'd like to start ordering from by completing
        this form.
      </p>
    </div>
    <div>
      <a
        href="https://support.provi.com/s/article/how-to-apply-for-a-distributor-account-on-provi"
        target="_blank"
        rel="noopener noreferrer"
        class="fizz-text-strong cursor-pointer"
      >
        Help
      </a>
    </div>
  </div>
</header>
